module.exports = __webpack_public_path__ + "static/media/OBE_interior2-min.d65392b3.jpg";